import styled from 'styled-components';

type props = {
  active: boolean;
};

export const Body = styled.div<props>`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  border-radius: 1rem;
  min-height: ${({ active }) => (active ? '15rem' : 'auto')};
`;

export const Container = styled.div<props>`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;
  width: 100%;
  max-width: 20rem;
  height: auto;
  margin-left: ${({ active }) => (active ? '-9rem' : '0')};

  .message-card-user {
    display: flex;
    justify-content: flex-start;
    text-decoration: underline;
    border: none;
    justify-content: center;
    font-weight: lighter;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.tertiary_500};
    transition: opacity 0.2s;
    margin: 0;
    padding: 0;

    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
      margin-right: 0.2rem;
    }

    :hover {
      opacity: 0.75;
    }
  }

  .content-infos {
    display: flex;
    justify-content: center;
    margin: 0 0 1rem 1rem;
    flex-direction: column;
    align-items: center;

    .contentExpandedCard {
      display: flex;
      flex-direction: column;
      width: 95%;

      h2 {
        font-size: 1.3rem;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.primary};
      }

      p {
        color: ${({ theme }) => theme.colors.gray_300};
        letter-spacing: 0px;
        opacity: 1;
        font-weight: 200;
        max-height: 3rem;
        overflow-y: auto;
        overflow-x: hidden;
        max-width: 20rem;
        font-size: 0.8rem;
        color: ${({ theme }) => theme.colors.text_gray};

        ::-webkit-scrollbar {
          width: 8px;
          background-color: ${({ theme }) => theme.colors.background_white};
          border-radius: 10px;
        }

        ::-webkit-scrollbar:horizontal {
          height: 5px;
        }

        ::-webkit-scrollbar-track,
        ::-webkit-scrollbar-track-horizontal {
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb,
        ::-webkit-scrollbar-thumb:horizontal {
          background-color: ${({ theme }) => theme.colors.tertiary_500};
          border-radius: 10px;
        }
      }
      .title {
        display: flex;
        align-items: center;
        padding: 0;
        margin-left: -0.5rem;
        color: ${({ theme }) => theme.colors.primary};
        font-size: 1rem;
      }
      .content {
        display: flex;
        color: ${({ theme }) => theme.colors.text_gray};
        font-size: 1.1rem;
        max-width: 15rem;
        margin: 0;
        padding: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .counterProposal {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        h1 {
          display: flex;
          align-items: center;
          font-size: 1.3rem;
          font-weight: 400;
          color: ${({ theme }) => theme.colors.secondary};

          span {
            color: ${({ theme }) => theme.colors.primary};
            padding: 0 0.2rem;
          }
        }

        p {
          color: ${({ theme }) => theme.colors.text_gray};
          font-size: 1.1rem;
          font-weight: 400;
          max-height: 40px;
        }

        .contentJustification {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .contentButtons {
          display: flex;
          flex-direction: row;
        }

        button {
          width: 100% !important;
        }
      }
    }

    .content-buttons {
      display: flex;
      flex-direction: column;
      padding: ${({ active }) => (active ? '1rem 0' : '0')};
      width: 100%;

      p {
        display: flex;
        font-size: 0.9rem;
        color: ${({ theme }) => theme.colors.text_gray};
      }

      button {
        width: auto !important;

        .containerItens {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0;
          }
        }
      }
    }
  }

  @media (min-width: 680px) and (max-width: 1200px) {
    width: 95%;
  }

  @media (max-width: 690px) {
    position: ${({ active }) => (active ? 'inherit' : 'relative')};

    .content-infos {
      margin: 0 0 1rem 0;
    }

    .content-infos {
      display: flex;
      justify-content: center;
      margin: 0 0 1rem 1rem;
      flex-direction: column;
      align-items: center;
    }

    .contentExpandedCard .counterProposal .contentButtons {
      flex-direction: column;
    }
  }

  @media (max-width: 360px) {
    .content-infos .contentExpandedCard .counterProposal h1 {
      flex-direction: column;
      align-items: start;
    }
  }
`;

export const Content = styled.div`
  min-height: 4rem;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-height: 2rem;
    width: 80%;

    .headerName {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      h1 {
        justify-content: center;
        align-items: center;
        font-size: 1.3rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        span {
          font-size: 1.3rem;
        }
      }
    }
  }

  img {
    display: flex;
    position: relative;
    margin: 0 0 0 -2rem;
    border-radius: 100%;
    min-height: 3.3rem;
    min-width: 3.3rem;
    max-height: 3.3rem;
    max-width: 3.3rem;
  }

  .containerCard {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
    max-height: 10rem;
    align-items: center;
    align-self: center;
  }

  .nameCurrentUser {
    align-items: flex-start;
    height: 1rem;
    max-height: 1rem;
    max-width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .content-icons-header {
    display: flex;
    align-items: center;
  }

  .view-user {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    border-radius: 100%;
    color: ${({ theme }) => theme.colors.tertiary_500};
    transition: opacity 0.2s;

    :hover {
      opacity: 0.55;
    }

    svg {
      width: 1rem;
      height: auto;
      margin: 0.2rem;
    }
  }

  .verified {
    width: 0.7rem;
    height: auto;
  }
`;
